import React from "react";
import { Helmet } from "react-helmet-async";
import "../styles/consulting.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhyCloudare from "../components/WhyCloudare";
import FaqSection from "../components/FaqSection";
import "../styles/LandscapeCard.css";
import "../styles/my.css";
import "../styles/us.css";

import ProductLanding from "../components/productLanding";
import bgUsa from "../assests/images/usa-first.png";

// Real, named client logos — no fake repetition
import Clover from "../assests/logo/Usa_Logos/Clover_Infotech.png";
import Liquidity from "../assests/logo/Usa_Logos/Liquidity_services.webp";
import Think from "../assests/logo/Usa_Logos/Think_Perfect.webp";
import Wia from "../assests/logo/Usa_Logos/Wia_System.webp";
import Innova from "../assests/logo/Usa_Logos/Innova.webp";


import { canonicalFor, PAGE_META } from "../config/site";

const meta = PAGE_META["/staffing"];

// Real client roster, no repetition, with correct alt text
const CLIENT_ROSTER = [
  { src: Clover, name: "Clover Infotech", width: 120 },
  { src: Liquidity, name: "Liquidity Services", width: 120 },
  { src: Think, name: "Think Perfect", width: 80 },
  { src: Innova, name: "Innova", width: 120 },
  { src: Wia, name: "WIA Systems", width: 100 },
];

function StaffingPage() {
  return (
    <React.Fragment>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <link rel="canonical" href={canonicalFor("/staffing")} />
      </Helmet>

      <div className="layout">
        <Navbar />
        <ProductLanding
          title="Unlock Top-Tier Talent"
          subtitle="Powering Your Success with Elite Professionals"
          content="Cloudare sources, vets and manages global professionals across IT, sales, marketing and product — connecting your business with talent that fits."
          label="Contact Us"
          trigger={true}
          src={bgUsa}
          id="staffing-hero"
        />
      </div>

      <div className="containery" style={{ marginTop: "40px" }}>
        <h2 className="h2y">Trusted by Growing Businesses</h2>
        <div className="statsy">
          <div className="staty">
            <span className="stat-valuey">100+</span>
            <span className="stat-descriptiony">Resources Placed</span>
          </div>
          <div className="staty">
            <span className="stat-valuey">2 Days</span>
            <span className="stat-descriptiony">Average time to match</span>
          </div>
          <div className="staty">
            <span className="stat-valuey">98.9%</span>
            <span className="stat-descriptiony">Satisfaction Rate</span>
          </div>
        </div>
      </div>

      <section className="wow-section-horizontal" style={{ marginTop: "25px" }}>
        <div className="wow-content-horizontal">
          <div className="left-horizontal">
            <h2>Build Your Dream Team</h2>
            <p className="wow-text-horizontal">
              With a wide range of specialities to cater to your needs.
            </p>
          </div>
          <div className="steps-horizontal">
            <div className="step-horizontal bg-step1">
              <div className="step-details-horizontal">
                <h2>Tell Us Your Skillset Needs</h2>
                <p>
                  Fill out a short form, and we'll call to understand your
                  requirements.
                </p>
              </div>
            </div>
            <div className="step-horizontal bg-step2">
              <div className="step-details-horizontal">
                <h2>We Find the Best Talent</h2>
                <p>Get a list of pre-vetted candidates within 2 days.</p>
              </div>
            </div>
            <div className="step-horizontal bg-step3">
              <div className="step-details-horizontal">
                <h2>Schedule Interviews</h2>
                <p>Select and interview the candidates that fit your needs.</p>
              </div>
            </div>
            <div className="step-horizontal bg-step4">
              <div className="step-details-horizontal">
                <h2>Start Deployment</h2>
                <p>
                  Kickstart your project with a no-risk, 2-week trial period.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="clients-sectionksa" style={{ marginTop: "-30px" }}>
        <h2 className="h2ksa" style={{ marginBottom: "45px" }}>
          Our Clients
        </h2>
        <div className="clients-sliderksa">
          <div className="clientsksa">
            {CLIENT_ROSTER.map((c) => (
              <div className="clientksa" key={c.name} style={{ width: "8%" }}>
                <img
                  src={c.src}
                  alt={`${c.name} logo`}
                  style={{ width: `${c.width}px` }}
                  className="imgksa"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <WhyCloudare
        title="Why Cloudare Staffing"
        features={[
          { icon: "ShieldCheck", title: "Hire With Confidence", body: "If you are not happy with the profiles, you pay nothing." },
          { icon: "Translate", title: "Fluent English Speakers", body: "Excellent communicators who take ownership of business and product objectives." },
          { icon: "ChartLine", title: "High Quality / Cost Ratio", body: "High-caliber talent at a sensible share of CTC." },
          { icon: "Clock", title: "Quick Turnarounds", body: "Get matched with highly compatible talent within days." },
          { icon: "Eye", title: "Full Transparency", body: "View work history, portfolios and more before you decide." },
          { icon: "Stack", title: "100+ Skills Available", body: "IT skills like Oracle, SAP, React, Node, Python, Angular, Swift, React Native, Android, Java, DevOps, ML — plus Non-IT like Sales, Marketing and PMO." },
        ]}
      />

      <WhyCloudare
        title="What skills will drive your vision?"
        elevated
        features={[
          { icon: "CodeBlock", title: "Software Development", body: "IT candidates with a balanced combination of technical prowess, analytical thinking, soft skills and a commitment to continuous learning." },
          { icon: "Handshake", title: "Sales", body: "Sales candidates with experience, strong communication skills and a customer-focused approach — motivation and fit assessed through interviews and reference checks." },
          { icon: "Megaphone", title: "Marketing", body: "Marketing candidates with relevant experience, strong communication skills and creativity — analytical skills and cultural fit assessed through interviews and portfolio reviews." },
          { icon: "Package", title: "Product Management", body: "Product candidates with relevant experience, excellent communication and strategic thinking — prioritisation and teamwork evaluated through interviews and practical exercises." },
        ]}
      />

      {/* Training & Enablement */}
      <WhyCloudare
        title="Training & enablement"
        lede="Beyond placement, Cloudare upskills your teams and our deployed talent — so capability stays in-house long after go-live."
        elevated
        features={[
          { icon: "Database", title: "Oracle & ERP training", body: "Hands-on Oracle Fusion, EBS, OIC and APEX training for finance, IT and functional teams — role-based, not generic." },
          { icon: "Receipt", title: "E-invoicing & compliance", body: "Workshops on ZATCA, GST, PINT AE and LHDN — how mandates work and how they run inside your ERP." },
          { icon: "Books", title: "Zoho & Odoo enablement", body: "Admin and end-user enablement so your team can operate and extend Zoho or Odoo confidently." },
          { icon: "UsersThree", title: "Onboarding & knowledge transfer", body: "Structured KT at the close of every project, plus onboarding programmes for new and deployed staff." },
          { icon: "CodeBlock", title: "Developer upskilling", body: "Practical upskilling in modern stacks and integration patterns for engineering teams and bench talent." },
          { icon: "ClipboardText", title: "Custom corporate programmes", body: "Tailored learning tracks built around your tools, processes and compliance footprint." },
        ]}
      />

      <WhyCloudare
        title="How can we help?"
        features={[
          { icon: "ClipboardText", title: "Project Scope (Gap Analysis)", body: "Every project starts with thorough research and clear scope definition, so the engagement stays efficient and free of unwanted delays." },
          { icon: "Database", title: "Implementation", body: "Our certified consultants deliver structured implementation with defined milestones, clean configuration, and rigorous testing before go-live." },
          { icon: "ListChecks", title: "Support", body: "Post go-live, our team provides ongoing AMS, enhancements and responsive support so your systems keep running smoothly." },
        ]}
      />

      <div id="faq">
        <FaqSection
          title="Staffing & training — FAQ"
          faqs={[
            {
              question: "How long does it take to hire resources?",
              answer:
                "It varies by role. Entry-level positions can close in a couple of weeks; senior, technical or executive roles take longer. Our team typically completes the entire process within 15–20 days.",
            },
            {
              question: "Who takes responsibility for managing the employee?",
              answer:
                "Once we deploy a candidate to a client, the candidate operates under the client's management. Cloudare does not intermediate for attendance, performance or day-to-day matters.",
            },
            {
              question: "Can you provide the same resource on a contract basis?",
              answer:
                "Yes — the commercial terms differ and can be discussed.",
            },
            {
              question: "How does the payment cycle work?",
              answer:
                "Standard payment cycle is NET 30 days after the candidate successfully joins. This can be adjusted case by case.",
            },
            {
              question: "What if our CTC budget is tight?",
              answer:
                "Our team works closely with you to identify candidates that fit your budget without compromising quality.",
            },
            {
              question: "What if none of the resources are shortlisted by our hiring team?",
              answer:
                "We adapt the search until we find the right fit. Most niche roles close within two rounds of candidate slates.",
            },
          ]}
          emitJsonLd
        />
      </div>

      <Footer />
    </React.Fragment>
  );
}

export default StaffingPage;
